export const hasPermission = (permission, orgId) => {
  try {
    const profileData = JSON.parse(localStorage.getItem('profileData') || '{}');
    console.log('Profile data:', profileData);
    const selectedOrg = profileData.Orgs?.find(org => org.OrgId === orgId);
    console.log('Selected org:', selectedOrg);
    const permissions = selectedOrg?.Permissions.map(p => p.Name) || [];
    
    console.log('Checking permission:', {
      permission,
      orgId,
      availablePermissions: permissions
    });
    
    return permissions.includes(permission);
  } catch (error) {
    console.error('Error checking permission:', error);
    return false;
  }
};

// Helper function to get all permissions for an organization
export const getOrgPermissions = (orgId) => {
  try {
    const profileData = JSON.parse(localStorage.getItem('profileData') || '{}');
    const org = profileData.Orgs?.find(org => org.OrgId === orgId);
    return org?.Permissions?.map(p => p.Name) || [];
  } catch (error) {
    console.error('Error getting organization permissions:', error);
    return [];
  }
};

export const updateCurrentOrgPermissions = (orgId) => {
  try {
    const profileData = JSON.parse(localStorage.getItem('profileData') || '{}');
    const org = profileData.Orgs?.find(org => org.OrgId === orgId);
    
    if (org && org.Permissions) {
      const permissions = org.Permissions.map(p => p.Name);
      localStorage.setItem('currentOrgPermissions', JSON.stringify(permissions));
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error updating organization permissions:', error);
    return false;
  }
};

// Example usage
hasPermission('room:create', 'org_Z5sYQJ-0eGkkbiCd'); 